export default "__VITE_ASSET__9wKjU_KQ__"